import { Divider, Stack, Typography, styled } from "@mui/material";
import React from "react";
import { CalenderIcon } from "components/navigation/bottomNavigation/CustomIcon";
import moment from 'moment-jalaali';
import { ItemTitleSmHead } from "components/typography/text";
import { ApiUrls, HostName } from "services/utils/globalVariables";
import useFetch from "services/hooks/useFetch";
import logoSrc from "assets/images/Logo.svg"

const NotifCardContainer = styled(Stack)(
    ({ theme }) => `
        background: white;
        padding: ${theme.spacing(2)};
        padding-bottom: ${theme.spacing(1)};
        border-radius: var(--border-radius);
        box-shadow: ${theme.shadows[3]};
    `
)

const NotifImage = {
    borderRadius: "0 8px 8px 0",
    width: "80px",
    aspectRatio: "4/3"
}

export default function NotifCard({ data }) {

    const [{}, doFetch] = useFetch(ApiUrls.SeenNotification, "post")

    //Open notification link THEN call an API for senn Notif
    const navigateToLink = () => {
        doFetch([data.Id])
        window.open(data.LinkUrl, "_blank")
    }

    return (
        <NotifCardContainer direction="row" spacing={2} onClick={navigateToLink}>
            {
                !!data.ImageUrl ?
                    <img src={`${HostName}/${data.ImageUrl}`} style={NotifImage} />
                :
                    <img src={logoSrc} style={{...NotifImage, opacity: "0.5"}} />
            }
            <Stack spacing={2}>
                <ItemTitleSmHead>{data.Title}</ItemTitleSmHead>
                <Stack direction="row" alignItems="center" spacing={1}>
                    <span style={{color: "var(--mc1)"}} ><CalenderIcon /></span>
                    <Typography sx={{color: "#656565"}}> {moment(data.CreatedDate).format("jYYYY/jMM/jDD")} </Typography>
                    <Divider orientation="vertical" />
                    <Typography sx={{color: "#656565"}}> {moment(data.CreatedDate).format("hh:mm")} </Typography>
                </Stack>
            </Stack>
        </NotifCardContainer>
    )
}